import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { GoogleMapsModule } from '@angular/google-maps';

import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatStepperModule } from '@angular/material/stepper';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatGridListModule } from '@angular/material/grid-list';
import { LayoutComponent } from './components/layout/layout.component';
import { UnderConstructionComponent } from './components/under-construction/under-construction.component';
import { SignTableComponent } from './components/sign-table/sign-table.component';
import { CreateSignComponent } from './screens/create-sign/create-sign.component';

import { AuthGuard } from './auth/auth.guard';
import { LoginPageComponent } from './screens/login-page/login-page.component';
import { NotFoundPageComponent } from './screens/not-found-page/not-found-page.component';
import { AgentDashboardComponent } from './screens/agent-dashboard/agent-dashboard.component';
import { LayoutAdminComponent } from './components/layout-admin/layout-admin.component';
import { SignTableAdminComponent } from './components/sign-table-admin/sign-table-admin.component';
import { AppComponent } from './app.component';
import { ScheduleWorkTableAdminComponent } from './components/schedule-work-table-admin/schedule-work-table-admin.component';
import { ScheduleTodoListAdminComponent } from './components/schedule-todo-list-admin/schedule-todo-list-admin.component';
import { RequestTypeComponent } from './components/request-type/request-type.component';
import { CollectStraySignComponent } from './components/collect-stray-sign/collect-stray-sign.component';
import { CollectChangeSignTableComponent } from './components/collect-change-sign-table/collect-change-sign-table.component';
import { InvoiceGenerateAdminComponent } from './components/invoice-generate-admin/invoice-generate-admin.component';
import { FirstLoginPageComponent } from './screens/first-login-page/first-login-page.component';
import { WorkCompletedTableAdminComponent } from './components/work-completed-table-admin/work-completed-table-admin.component';
import { SignTableNestedComponent } from './components/sign-table-nested/sign-table-nested.component';
import { SignTableNestedExampleComponent } from './components/sign-table-nested-example/sign-table-nested-example.component';
import { HomepageAgentComponent } from './components/homepage-agent/homepage-agent.component';
import { MatDividerModule } from '@angular/material/divider';
import { BoardActivityComponent } from './components/board-activity/board-activity.component';
import { AdminPanelComponent } from './screens/admin-panel/admin-panel.component';
import { LogsViewerComponent } from './components/logs-viewer/logs-viewer.component';

const routes: Routes = [
  { path: '404', component: NotFoundPageComponent },
  { path: 'login', component: LoginPageComponent },
  {
    path: 'first-login',
    component: FirstLoginPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '',
    component: AppComponent,
    canActivate: [AuthGuard],
    // runGuardsAndResolvers: 'always',
    children: [
      {
        path: 'admin',
        canActivateChild: [AuthGuard],
        component: LayoutAdminComponent,
        children: [
          {
            path: 'dashboard',
            children: [
              {
                path: '',
                component: AgentDashboardComponent,
              },
            ],
          },
          {
            path: 'signs',
            component: SignTableAdminComponent,
          },
          {
            path: 'schedule',
            component: ScheduleWorkTableAdminComponent,
          },
          {
            path: 'todo-list',
            component: ScheduleTodoListAdminComponent,
          },
          {
            path: 'complete-work',
            component: WorkCompletedTableAdminComponent,
          },
          // {
          //   path: 'complete-work',
          //   component: UnderConstructionComponent,
          // },
          {
            path: 'invoice',
            component: InvoiceGenerateAdminComponent,
          },
          {
            path: 'settings',
            component: AdminPanelComponent,
          },
          {
            path: 'logs',
            component: LogsViewerComponent,
          },
        ],
      },
      {
        path: 'agent',
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        children: [
          {
            path: 'dashboard',
            children: [
              {
                path: '',
                component: AgentDashboardComponent,
              },
            ],
          },
          {
            path: 'request',
            component: RequestTypeComponent,
            children: [
              {
                path: 'sign',
                component: CreateSignComponent,
              },
              {
                path: 'sign/:id',
                component: CreateSignComponent,
              },
              {
                path: 'collect',
                component: CollectStraySignComponent,
              },
              {
                path: 'change-table',
                component: CollectChangeSignTableComponent,
              },
            ],
          },
          {
            path: 'signs',
            component: SignTableComponent,
          },
          {
            path: 'board-activity',
            component: BoardActivityComponent,
          },
        ],
      },
      {
        path: 'branch',
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        children: [
          {
            path: 'homepage',
            component: RequestTypeComponent,
            children: [
              {
                path: '',
                component: HomepageAgentComponent,
              },
            ],
          },
          {
            path: 'request',

            component: RequestTypeComponent,
            children: [
              {
                path: 'sign',
                component: CreateSignComponent,
              },
              {
                path: 'sign/:id',
                component: CreateSignComponent,
              },
              {
                path: 'collect',
                component: CollectStraySignComponent,
              },
              {
                path: 'change-table',
                component: CollectChangeSignTableComponent,
              },
            ],
          },
          {
            path: 'signs',
            component: SignTableComponent,
          },
          {
            path: 'signs-v2-example',
            component: SignTableNestedExampleComponent,
          },
          {
            path: 'signs-v2',
            component: SignTableNestedComponent,
          },
          {
            path: 'board-activity',
            component: BoardActivityComponent,
          },
        ],
      },
      {
        path: 'wip',
        component: UnderConstructionComponent,
        canActivate: [AuthGuard],
        // runGuardsAndResolvers: 'always',
        children: [],
      },
    ],
  },
  { path: '**', redirectTo: '404' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'ignore',
      enableTracing: false,
    }),
    GoogleMapsModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  exports: [
    RouterModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatToolbarModule,
    MatListModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatInputModule,
    MatSelectModule,
    MatCardModule,
    MatProgressBarModule,
    GoogleMapsModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatBadgeModule,
    MatDatepickerModule,
    DragDropModule,
    MatStepperModule,
    MatRadioModule,
    MatMenuModule,
    MatTooltipModule,
    MatExpansionModule,
    MatGridListModule,
    MatDividerModule,
  ],
})
export class AppRoutingModule {}
